<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2022-06-01 08:28:56
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-08-21 09:56:33
-->
<template>
  <div class="table-search" v-if="props.columns.length">
    <Form
      ref="formRef"
      name="advanced_search"
      class="ant-advanced-search-form"
      :model="props.searchParam"
      @finish="onFinish"
      label-align="left"
      layout="vertical"
    >
      <Row :gutter="24">
        <template v-for="(item, i) in props.columns.filter((_) => !_.hideItem)" :key="i">
          <Col v-show="(expand || i <= 3) && !item.searchHide" :span="props.span || 6">
            <component
              v-if="item.component"
              :searchParam="props.searchParam"
              :item="item"
              :is="item.component"
            ></component>
            <FormItem v-else :name="item.prop" :label="item.label">
              <SearchFormItem :searchParam="props.searchParam" :item="item">
                <template #[`item.prop`]>
                  <!-- <h1>123456</h1> -->
                  <slot v-bind="{ item }" :name="item.prop">123</slot>
                </template>
                <!-- <template #test>
                  <Button style="margin: 0 8px" @click="() => reset()">重 置</Button>
                </template> -->
              </SearchFormItem>
            </FormItem>
          </Col>
        </template>
      </Row>

      <Row class="form-btn" v-if="isShowSearchBtn() === false">
        <Col :span="24" style="text-align: right">
          <Button style="margin: 0 8px" @click="() => reset()">重 置</Button>
          <Button type="primary" :loading="loading" html-type="submit">查 询</Button>
          <a v-if="props.columns?.length > 4" style="font-size: 12px; margin-left: 20px" @click="expand = !expand">
            <template v-if="expand">
              <UpOutlined />
              收起
            </template>
            <template v-else>
              <DownOutlined />
              展开
            </template>
          </a>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script setup lang="ts" name="searchForm">
  import { ref } from 'vue'
  import { ColumnProps } from '@/components/model/tableModel'
  import SearchFormItem from '../searchForm/SearchFormItem.vue'
  import { DownOutlined, UpOutlined } from '@ant-design/icons-vue'
  import { Form, Row, Col, FormItem, Button, Input } from 'ant-design-vue'
  import type { FormInstance } from 'ant-design-vue'

  interface ProTableProps {
    columns: Partial<ColumnProps>[] // 搜索配置列
    searchParam: any // 搜索参数
    span: any //控制item长度，一行展示几个span
    loading?: boolean
  }

  // 默认值
  const props = withDefaults(defineProps<ProTableProps>(), {
    columns: () => [],
    searchParam: {}
  })

  const isShowSearchBtn = () => {
    let searchBtn = props.columns.every((item) => {
      return item.searchHide === true
    })
    return searchBtn
    console.log(searchBtn)
  }
  //给接口提供真实字段恢复默认值
  const clearRealField = () => {
    props.columns.forEach((col) => {
      col.realField &&
        col.realField.forEach((field, i) => {
          props.searchParam![field] = props.searchParam[col.prop!]?.[i]
        })
    })
  }
  const expand = ref(false)
  const formRef = ref<FormInstance>()
  /**是否操作过重置 */
  const isReset = ref(false)

  const emit = defineEmits(['search'])

  const onFinish = (values: any) => {
    isReset.value = false
    emit('search')
  }

  const reset = () => {
    if (isReset.value || props.loading) return
    isReset.value = true
    formRef.value?.resetFields()
    clearRealField()
    emit('search')
  }
</script>

<style lang="less" scoped>
  :deep(.ant-picker) {
    width: 100%;
  }
  .table-search {
    padding: 0 24px;
  }
  .form-btn {
    margin-bottom: 16px;
  }
</style>
